import { useReducedMotion } from 'framer-motion';
import type { TargetAndTransition, Transition } from 'framer-motion';

const SUCCESS_EASE = [0.22, 1, 0.36, 1] as const;
const SUCCESS_DURATION_SECONDS = 0.45;
const ICON_ENTRANCE_DELAY_SECONDS = 0;
const TITLE_ENTRANCE_DELAY_SECONDS = 0.2;
const SUBTITLE_ENTRANCE_DELAY_SECONDS = 0.4;

export type SuccessAnimationStep = {
  initial: TargetAndTransition;
  animate: TargetAndTransition;
  transition: Transition;
};

export type UseSuccessAnimationResult = {
  reduceMotion: boolean;
  icon: SuccessAnimationStep;
  title: SuccessAnimationStep;
  subtitle: SuccessAnimationStep;
};

const STATIC_STEP: SuccessAnimationStep = {
  initial: {},
  animate: {},
  transition: { duration: 0 },
};

function createFadeSlideStep(delaySeconds: number): SuccessAnimationStep {
  return {
    initial: { opacity: 0, y: 16 },
    animate: { opacity: 1, y: 0 },
    transition: {
      duration: SUCCESS_DURATION_SECONDS,
      ease: SUCCESS_EASE,
      delay: delaySeconds,
    },
  };
}

function createIconStep(delaySeconds: number): SuccessAnimationStep {
  return {
    initial: { opacity: 0, scale: 0.85 },
    animate: { opacity: 1, scale: 1 },
    transition: {
      duration: SUCCESS_DURATION_SECONDS,
      ease: SUCCESS_EASE,
      delay: delaySeconds,
    },
  };
}

export function useSuccessAnimation(): UseSuccessAnimationResult {
  const reduceMotion = useReducedMotion() ?? false;

  if (reduceMotion) {
    return {
      reduceMotion: true,
      icon: STATIC_STEP,
      title: STATIC_STEP,
      subtitle: STATIC_STEP,
    };
  }

  return {
    reduceMotion: false,
    icon: createIconStep(ICON_ENTRANCE_DELAY_SECONDS),
    title: createFadeSlideStep(TITLE_ENTRANCE_DELAY_SECONDS),
    subtitle: createFadeSlideStep(SUBTITLE_ENTRANCE_DELAY_SECONDS),
  };
}
